import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

type UseReactRouterBlockerParams = {
  shouldBlock: boolean;
  message: string;
};

/**
 * Hook to block React Router navigation with a confirmation dialog
 * Uses React Router v6's useBlocker API
 */
export const useReactRouterBlocker = ({ shouldBlock, message }: UseReactRouterBlockerParams) => {
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const leave = window.confirm(message);
      leave ? blocker.proceed() : blocker.reset();
    }
  }, [blocker, message]);
};

export default useReactRouterBlocker;
